import { ApolloError } from '@apollo/client'
import { useCurrentUserQuery } from 'generated/graphql'
import { openChannelDeactivatedModal } from '@app.components/modals/ChannelDeactivatedModal'
import { useOpenCustomerMessageForm } from 'components/customer-message-form'
import useErrorSnackbar from 'hooks/useErrorSnackbar'

const useChannelError = () => {
  const { enqueueApolloError } = useErrorSnackbar()
  const currentUserQuery = useCurrentUserQuery()
  const openCustomerMessageForm = useOpenCustomerMessageForm()

  const onError = (error?: ApolloError) => {
    if (currentUserQuery.data?.currentUser?.channel?.deactivatedAt) {
      openChannelDeactivatedModal({
        open: true,
        onConfirm: openCustomerMessageForm,
      })
      return true
    } else if (error) {
      enqueueApolloError(error)
      return !!error
    }
  }

  return onError
}
export default useChannelError
